import ReactModal from 'react-modal';
import React from 'react';
import { createModal } from 'react-modal-promise';

const AdjustmentCreditConfirmModal = ({ open, close }) => (
  <ReactModal
    appElement={document.getElementById('root')}
    isOpen={open}
    contentLabel="Minimal Modal Example"
    portalClassName="AdjustmentCreditPortal"
    overlayClassName="AdjustmentCreditModal__Overlay"
    className="AdjustmentCreditModal__Content"
  >
    <div className="modal-header">
      <span className="close">&times;</span>
      <h2>Confirm Adjustment Credit</h2>
    </div>
    <div className="modal-body">
      <p>
        Are you sure you want to create and apply an adjustment credit? This
        will write-off the invoice.
      </p>
    </div>
    <div className="modal-footer">
      <button className={'btn btn-primary'} onClick={() => close(true)}>
        Confirm
      </button>
      <button className={'btn'} onClick={() => close(false)}>
        Cancel
      </button>
    </div>
  </ReactModal>
);

export default createModal(AdjustmentCreditConfirmModal);
